import React, { useState } from "react";
import { FaFilter, FaSearch, FaChevronDown, FaCalendarAlt } from "react-icons/fa";
import { MdOutlineCategory, MdSwapVert } from "react-icons/md";
import "./FinancialFilter.css";

const FinancialFilter = ({ filters, setFilters, TYPE_OPTIONS, CATEGORY_OPTIONS }) => {
  const [open, setOpen] = useState(false);

  const set = (key) => (e) =>
    setFilters((prev) => ({ ...prev, [key]: e.target.value }));

  const activeCount = [
    filters.search,
    filters.type !== "ALL" && filters.type,
    filters.category !== "ALL" && filters.category,
    filters.dateFrom,
    filters.dateTo,
  ].filter(Boolean).length;

  const clearAll = (e) => {
    e.stopPropagation();
    setFilters((prev) => ({
      ...prev,
      search: "",
      type: "ALL",
      category: "ALL",
      dateFrom: "",
      dateTo: "",
    }));
  };

  return (
    <div className="ff-wrapper">
      {/* Header — clickable on mobile to collapse */}
      <div className="ff-header" onClick={() => setOpen((v) => !v)}>
        <div className="ff-header-left">
          <FaFilter className="ff-icon" />
          <span className="ff-title">Filtrar resultados</span>
          {activeCount > 0 && <span className="ff-badge">{activeCount}</span>}
        </div>
        <div className="ff-header-right">
          {activeCount > 0 && (
            <button type="button" className="ff-clear-btn" onClick={clearAll}>
              Limpar
            </button>
          )}
          <FaChevronDown className={`ff-chevron ff-chevron-mobile ${open ? "open" : ""}`} />
        </div>
      </div>

      {/* Body */}
      <div className={`ff-body ${open ? "open" : ""}`}>
        <div className="ff-body-inner">
          <div className="ff-fields">
            {/* Search */}
            <div className="ff-field">
              <span className="ff-field-label">
                <FaSearch /> Busca
              </span>
              <div className="ff-input-wrap">
                <FaSearch className="ff-input-icon" />
                <input
                  type="text"
                  className="ff-input with-icon"
                  placeholder="Descrição ou observação…"
                  value={filters.search}
                  onChange={set("search")}
                />
              </div>
            </div>

            {/* Tipo */}
            <div className="ff-field">
              <span className="ff-field-label">
                <MdSwapVert /> Tipo
              </span>
              <div className="ff-input-wrap">
                <MdSwapVert className="ff-input-icon" />
                <select
                  className={`ff-select with-icon ${filters.type !== "ALL" ? "has-value" : ""}`}
                  value={filters.type}
                  onChange={set("type")}
                >
                  <option value="ALL">Todos</option>
                  {TYPE_OPTIONS.map((o) => (
                    <option key={o.value} value={o.value}>{o.label}</option>
                  ))}
                </select>
                <FaChevronDown className="ff-select-arrow" />
              </div>
            </div>

            {/* Categoria */}
            <div className="ff-field">
              <span className="ff-field-label">
                <MdOutlineCategory /> Categoria
              </span>
              <div className="ff-input-wrap">
                <MdOutlineCategory className="ff-input-icon" />
                <select
                  className={`ff-select with-icon ${filters.category !== "ALL" ? "has-value" : ""}`}
                  value={filters.category}
                  onChange={set("category")}
                >
                  <option value="ALL">Todas</option>
                  {CATEGORY_OPTIONS.map((o) => (
                    <option key={o.value} value={o.value}>{o.label}</option>
                  ))}
                </select>
                <FaChevronDown className="ff-select-arrow" />
              </div>
            </div>

            {/* Datas — agrupadas em tablet, células separadas no desktop */}
            <div className="ff-date-group">
              <div className="ff-field">
                <span className="ff-field-label">
                  <FaCalendarAlt /> De
                </span>
                <div className="ff-input-wrap">
                  <input
                    type="date"
                    className="ff-input"
                    value={filters.dateFrom}
                    onChange={set("dateFrom")}
                  />
                </div>
              </div>

              <div className="ff-field">
                <span className="ff-field-label">
                  <FaCalendarAlt /> Até
                </span>
                <div className="ff-input-wrap">
                  <input
                    type="date"
                    className="ff-input"
                    value={filters.dateTo}
                    onChange={set("dateTo")}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FinancialFilter;
